export const WmsTaskStatus = {
    IDLE: 'idle',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
    PARTIALLY_COMPLETE: 'partiallyComplete' // This isn't a "real" status. It is calculated by checking if an item has been put in a trolley before the mission was ended.
}

export function getWmsTaskStatus() {
    return [
        WmsTaskStatus.IDLE,
        WmsTaskStatus.IN_PROGRESS,
        WmsTaskStatus.COMPLETED,
        WmsTaskStatus.CANCELLED
    ]
}

// These matches with the internal Badge component's color list.
export const WMSTaskStatusColor = {
    'idle': 'default',
    'in_progress': 'warning',
    'completed': 'online',
    'cancelled': 'error',
    'partiallyComplete': 'draft'
}